export class HrPayNameKey {
    private static readonly keyPrefix = 'hrPayName';
    public static listTitlePayName = `${HrPayNameKey.keyPrefix}.listTitlePayName`;
    public static payrollType = `${HrPayNameKey.keyPrefix}.payrollType`;
    public static pageHeaderPayName = `${HrPayNameKey.keyPrefix}.pageHeaderPayName`;
}
